import { ErrorBoundary } from "react-error-boundary";
import "./app.scss";
import { TabLayout } from "./layout/TabLayout";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Outlet, Route, Routes } from "react-router-dom";
import { NotFound } from "./layout/NotFound";
import { useMemo, useState } from "react";
import { DataModel } from "./models/data.model";
import { AppContext } from "./AppContext";
import { RoutePaths } from "./constants";
import { LandingPage } from "./layout/LandingPage";
import { PageFooter } from "./layout/PageFooter";

const Layout = () => {
  return (
    <>
      <div
        className="App"
        style={{
          display: "grid",
          minHeight: "100dvh",
          gridTemplateRows: "1fr auto",
        }}
      >
        <div>
          <Outlet />
        </div>
        <PageFooter />
      </div>
      <ToastContainer position="bottom-left" autoClose={3950} closeOnClick />
    </>
  );
};

export const App = () => {
  const [model, setModel] = useState<DataModel>({});
  const [activeTab, setActiveTab] = useState<number>(0);

  const value = useMemo(() => {
    return {
      model,
      setModel,
      activeTab,
      setActiveTab,
      reset: () => {
        setModel({});
        setActiveTab(0);
      },
    };
  }, [model, setModel, activeTab, setActiveTab]);

  return (
    <ErrorBoundary
      fallback={<div>Sorry, something went wrong. Please reload the page.</div>}
    >
      <BrowserRouter basename={process.env.PUBLIC_URL ?? ""}>
        <AppContext.Provider value={value}>
          <Routes>
            <Route element={<Layout />}>
              <Route path={RoutePaths.landing} element={<LandingPage />} />
              <Route path={RoutePaths.calculator} element={<TabLayout />} />
              <Route path="/*" element={<NotFound />} />
            </Route>
          </Routes>
        </AppContext.Provider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};
